import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import { getConfigVariable } from "../config/config";

const queries = (args = {}) => {
    const resource = "import_profile_mapping_logs";
    return [
        {
            resource,
            args: {
                projectId: { type: "String!", value: args.projectId },
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            isDatagridReq: true,
            body: "__typename, items { id, profile_name, rows_mapped, entity_name, config_set, status, started_at, completed_at }, total, hasMore, filters { prop, name, type, list, disableOperators, mandatory }",
        },
    ].filter((query) => query);
};

const dataSyncLog = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: App,
    exact,
    queries,
    title: [title],
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                total: "query(0).total",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                modifierssx: {
                    "& .sovosPaginationFooter > :first-child": {
                        display: "none",
                    },
                },
            },
        },
    ],
});

export default dataSyncLog;
